export function calculateDerivativeKpiMetric({
  kpi,
  spend,
  isRevenue,
}: {
  kpi: number;
  spend: number;
  isRevenue: boolean;
}) {
  if (isRevenue) {
    if (spend < 1) {
      return 0;
    }
    return kpi / spend;
  }

  if (kpi < 1) {
    return 0;
  }
  return spend / kpi;
}
